import React, { useContext, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Home from "../../screens/Home/Home";
import Login from "../../screens/Login/Login";
import SignUpOTPScreen from "../../screens/SignUpOTPScreen/SignUpOTPScreen";
import FMasterPage from "../FMasterPage/FMasterPage";
import { useProtectedRoute } from "./hooks/useProtectedRoute";
import ProviderComponent from "../../components/ProviderComponent/ProviderComponent";
import { AuthContext } from "../../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isAuth } = useProtectedRoute();
  let auth = isAuth();
  const sampleLocation = useLocation();
  const token = localStorage.getItem("token");
  const { setPathname } = useContext(AuthContext);
  setPathname(sampleLocation.pathname);

  if (sampleLocation.pathname == "/Login") {
    return !!token ? (
      <ProviderComponent>
        <FMasterPage>
          <Home />
        </FMasterPage>
      </ProviderComponent>
    ) : (
      <>
        <ProviderComponent>{children}</ProviderComponent>
      </>
    );
  } else if (sampleLocation.pathname == "/SignUpScreen") {
    return !!token ? (
      <div>
        <ProviderComponent>
          <FMasterPage>
            <Home />
          </FMasterPage>
        </ProviderComponent>
      </div>
    ) : (
      <>
        <ProviderComponent>{children}</ProviderComponent>
      </>
    );
  } else if (sampleLocation.pathname == "/RecoverPassword") {
    return !!token ? (
      <ProviderComponent>
        <FMasterPage>
          <Home />
        </FMasterPage>
      </ProviderComponent>
    ) : (
      <>
        <ProviderComponent>{children}</ProviderComponent>
      </>
    );
  } else if (sampleLocation.pathname == "/SignUpOTPScreen") {
    return !!token ? (
      <ProviderComponent>
        <FMasterPage>
          <Home />
        </FMasterPage>
      </ProviderComponent>
    ) : !!sampleLocation.state ? (
      <>
        <ProviderComponent>{children}</ProviderComponent>
      </>
    ) : (
      <ProviderComponent>
        <Login />
      </ProviderComponent>
    );
  } else if (sampleLocation.pathname == "/NewRecoverPassword") {
    return !!token ? (
      <ProviderComponent>
        <FMasterPage>
          <Home />
        </FMasterPage>
      </ProviderComponent>
    ) : !!sampleLocation.state ? (
      <>
        <ProviderComponent>{children}</ProviderComponent>
      </>
    ) : (
      <ProviderComponent>
        <Login />
      </ProviderComponent>
    );
  } else if (sampleLocation.pathname == "/SignInScreen") {
    return !!token ? (
      <ProviderComponent>
        <FMasterPage>
          <Home />
        </FMasterPage>
      </ProviderComponent>
    ) : !!sampleLocation.state ? (
      <>
        <ProviderComponent>{children}</ProviderComponent>
      </>
    ) : (
      <ProviderComponent>
        <Login />
      </ProviderComponent>
    );
  } else {
    return auth ? (
      <>
        <ProviderComponent>{children}</ProviderComponent>
      </>
    ) : (
      <ProviderComponent>
        <Login />
      </ProviderComponent>
    );
  }
};

export default ProtectedRoute;
